import { render } from "./BioDoArtista.vue?vue&type=template&id=234a960e&scoped=true"
import script from "./BioDoArtista.vue?vue&type=script&lang=js"
export * from "./BioDoArtista.vue?vue&type=script&lang=js"

import "./BioDoArtista.vue?vue&type=style&index=0&id=234a960e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234a960e"]])

export default __exports__